<template>
  <el-dialog :visible="innerVisible" :title="$t('Sop.sift')" width="1000px" :show-close="false" @open="open">
    <el-form label-position="right" label-width="90px">
      <el-row :gutter="5">
        <el-col v-for="(item,index) in searchForm" v-show="item.key !== 'lob' && item.key !== 'trackDetailIds' && (!item.isShow || (item.isShow && item.isShow.includes(lob)))" :key="`${item.key}${index}`" :span="8">
          <el-form-item :label="item.key === 'containerLoadType' && (lob === 'AE' || lob === 'AI') ? $t('SeaExport.OperateType') : $t(item.label)">
            <cargo-user-select
              v-if="item.type==='cargoAdvanceSelect' && item.props.selectType === 'basic_data_User'"
              :default-value="item.value"
              v-bind="item.props"
              :method-params="!item.props.methodParams ? {} : item.props.methodParams"
              style="width: 100%"
              @change="p=>item.value = p.value"
            />
            <cargo-advance-select
              v-else-if="item.type==='cargoAdvanceSelect' && item.props.selectType !== 'basic_data_User'"
              :disabled="lob ==='AI' && item.key === 'laneCode'"
              :default-value="item.props.multiple ? '' : item.value"
              v-bind="item.props"
              :method-params="!item.props.methodParams ? {} : item.props.methodParams"
              style="width: 100%"
              @parentCallBack="p => changeSelect(p, item)"
            />
            <component :is="item.type" v-else v-model="item.value" v-bind="item.props" style="width: 100%" @change="p=>changeDate(item)" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="clear">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
      <el-button type="primary" @click="handleFilter">{{ $t('common.btn.query') }}</el-button>
      <el-button @click="restForm">{{ $t('SeaExport.Cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import { getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import $store from '@/store'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import dateUtils from '@/utils/dateUtils'
import { queryCompanyUserByCompany } from '@/api/company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'MoreFilterDialog',
  components: { CargoUserSelect, CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    lob: {
      type: String,
      default: () => 'SE'
    },
    alertTypes: {
      type: Array,
      default: () => []
    },
    sopTemplates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      configContent: '',
      searchForm: [
        {
          key: 'jobNo',
          label: 'SeaExport.BusinessNo',
          type: 'el-input',
          value: ''
        },
        // 主单号
        {
          key: 'mblNo',
          label: 'SeaExport.Mbl2',
          type: 'el-input',
          value: '',
          isShow: ['SE', 'SI', 'AE', 'AI']
        },
        // 关单号
        {
          key: 'soNo',
          label: 'SeaExport.SoNo',
          type: 'el-input',
          value: '',
          isShow: ['SE', 'SI']
        },
        // 运单号
        {
          key: 'rMblNo',
          label: 'RailwayExport.mbl',
          type: 'el-input',
          value: '',
          isShow: ['RE', 'RI']
        },
        // CMR号
        {
          key: 'ieMblNo',
          label: 'Integrated.Mbl',
          type: 'el-input',
          value: '',
          isShow: ['IE']
        },
        // 发货地
        {
          key: 'dispatchingPlace',
          label: 'CargoMsg.Cargo_dispatchingPlace',
          type: 'el-input',
          value: '',
          isShow: ['IE']
        },
        {
          key: 'loadingPortCode',
          label: this.lob === 'IE' ? 'CargoMsg.Cargo_secondPol' : 'CargoMsg.Cargo_PortOfLoading',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: null,
            tagValue: 'code',
            cache: true,
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'destinationAgent',
          label: this.lob === 'IE' ? 'CargoMsg.Cargo_secondPod' : 'CargoMsg.Cargo_DestinationPort',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: null,
            tagValue: 'code',
            cache: true,
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'containerLoadType',
          label: 'CargoMsg.Cargo_FLCLType',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            cache: false,
            tagValue: 'code',
            filterable: true,
            staticOptions: []
          },
          isShow: ['SE', 'SI', 'AE', 'AI', 'RE', 'RI']
        }, {
          key: 'ieContainerLoadType',
          label: 'CargoMsg.Cargo_OrderType',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            cache: false,
            tagValue: 'code',
            filterable: true,
            staticOptions: []
          },
          isShow: ['IE']
        }, {
          key: 'plateNumber',
          label: 'CargoMsg.Cargo_khPlateNum',
          type: 'el-input',
          value: '',
          isShow: ['IE']
        }, {
          key: 'trailerNumber',
          label: 'CargoMsg.Cargo_khTrailerNumber',
          type: 'el-input',
          value: '',
          isShow: ['IE']
        }, {
          key: 'laneCode',
          label: 'CargoMsg.Cargo_Airline',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            cache: false,
            tagValue: 'code',
            tagName: 'name',
            filterable: true,
            staticOptions: []
          }
        }, {
          key: 'vessel',
          label: 'queryJob.vessel',
          type: 'el-input',
          value: ''
        }, {
          key: 'voyageFlight',
          label: 'queryJob.voyageFlight',
          type: 'el-input',
          value: ''
        },
        {
          key: 'createTime',
          label: 'Sop.warningAt',
          type: 'el-date-picker',
          value: '',
          props: {
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd'
          }
        }, {
          key: 'customerId',
          label: 'SeaExport.ConsignationCompany',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_Company',
            cache: true,
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'opDepartment',
          label: 'SeaExport.Department',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            officeId: this.$store.getters.currentOfficeId,
            selectType: 'basic_data_DepartmentAll',
            cache: true,
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'notifierId',
          label: 'CargoMsg.Cargo_NotifyParty',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_User',
            cache: true,
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'opId',
          label: 'SeaExport.Operation',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_User',
            cache: true,
            filterable: true,
            methodParams: { officeId: $store.getters.currentOfficeId, category: 'role', shape: 'op' },
            staticOptions: null
          }
        }, {
          key: 'dc',
          label: 'SeaExport.Documents',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_User',
            cache: true,
            filterable: true,
            methodParams: { officeId: $store.getters.currentOfficeId, category: 'role', shape: 'doc' },
            staticOptions: null
          }
        }, {
          key: 'csr',
          label: 'SeaExport.CustomerService',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_User',
            cache: true,
            methodParams: { officeId: $store.getters.currentOfficeId, category: 'role', shape: 'csr' },
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'overseaOp',
          label: 'SeaExport.OverseaCustomerService',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            selectType: 'basic_data_User',
            cache: true,
            methodParams: { officeId: $store.getters.currentOfficeId, category: 'role', shape: 'overseaOp' },
            filterable: true,
            staticOptions: null
          }
        }, {
          key: 'trackingTemplateUuid',
          label: 'CargoMsg.Cargo_SopTemplate',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            cache: false,
            tagValue: 'uuid',
            tagName: 'templateName',
            filterable: true,
            staticOptions: []
          }
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get(val) {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    fLclType() {
      const lob = this.lob
      if (!lob) {
        return []
      }
      if (lob === 'RE' || lob === 'RI' || lob === 'SE') {
        return ContainerLoadType.CONTAINERLOAD_TYPES
      }
      if (lob === 'SI') {
        return ImportConstants._cargoTypeInputList
      }
      return Array.from(ChargeUtils.getCargoType(lob))
    },
    loadingPortData() {
      const lob = this.lob
      if (!lob) {
        return []
      }
      if (lob === 'SE' || lob === 'SI' || lob === 'IE') {
        return getCacheListByKey(basicCacheKeys.basic_data_Seaport)
      }
      if (lob === 'AE' || lob === 'AI') {
        return getCacheListByKey(basicCacheKeys.basic_data_Airport)
      }
      return []
    },
    selectType() {
      const lob = this.lob
      if (lob === 'SE' || lob === 'SI' || lob === 'IE') {
        return 'basic_data_Seaport'
      }
      if (lob === 'AE' || lob === 'AI') {
        return 'basic_data_Airport'
      }
      return ''
    },
    hasSopOfCustomerForSelfSales() { // 是否有“SOP筛选委托单位仅销售个人的客户”
      return this.$checkPermission(['role_sales_SopOfCustomerForSelfSales'])
    }
  },
  methods: {
    async getFilterConfig() {
      if (this.configContent !== '') {
        this.searchForm = JSON.parse(this.configContent)
      } else {
        this.configContent = JSON.stringify(this.searchForm)
      }
      const getRegion = await this.getRegion()
      let companyOptions = null
      // 配置【SOP筛选委托单位仅销售个人的客户】权限时，仅查看属于自己的客户
      if (!this.$store.getters.isAdmin && this.hasSopOfCustomerForSelfSales) {
        await queryCompanyUserByCompany({ userId: this.$store.getters.userId, roleType: 2, lob: this.lob ? this.lob : 'ALL' }).then(res => {
          companyOptions = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.uuid) && p.active)
        })
      }
      this.searchForm.map((item) => {
        if (item.key === 'loadingPortCode' || item.key === 'destinationAgent') {
          item.props.staticOptions = this.loadingPortData
          item.props.selectType = this.selectType
        }
        if (item.key === 'containerLoadType' || item.key === 'ieContainerLoadType') {
          item.props.staticOptions = this.fLclType
        }
        if (item.key === 'laneCode') {
          item.props.staticOptions = getRegion
        }
        if (item.key === 'trackingTemplateUuid') {
          // item.props.methodParams = { lob: this.lob }
          item.props.staticOptions = this.sopTemplates
        }
        if (item.key === 'opId') {
          item.props.methodParams = { officeId: this.$store.getters.currentOfficeId, category: 'role', shape: 'op' }
        }
        if (item.key === 'dc') {
          item.props.methodParams = { officeId: this.$store.getters.currentOfficeId, category: 'role', shape: 'doc' }
        }
        if (item.key === 'csr') {
          item.props.methodParams = { officeId: this.$store.getters.currentOfficeId, category: 'role', shape: 'csr' }
        }
        if (item.key === 'customerId' && !this.$store.getters.isAdmin && this.hasSopOfCustomerForSelfSales) {
          item.props.staticOptions = companyOptions
        }
      })
    },
    // 获取海港空港航线
    async getRegion() {
      const lob = this.lob
      if (!lob) {
        return []
      }
      if (lob === 'SE' || lob === 'SI' || lob === 'AE') {
        const reg = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
        return reg
      }
      if (lob === 'RE' || lob === 'RI') {
        const reg = await getSpecificBasicData(basicCacheKeys.basic_data_RailwayLine)
        console.log('reg', reg)
        return reg
      }
      return []
    },
    clearDate(removeDate) {
      if (this.searchForm && this.searchForm.length > 0) {
        for (const data of this.searchForm) {
          if (data.key === 'createTime') {
            if (removeDate) {
              data.value = ''
            } else {
              const nowDate = dateUtils.formatStandardDate(new Date())
              data.value = [nowDate, nowDate]
            }
          }
        }
      }
      this.configContent = JSON.stringify(this.searchForm)
    },
    resetTrackingTemplate(templateKey) {
      if (this.searchForm && this.searchForm.length > 0) {
        for (const data of this.searchForm) {
          if (data.key === 'trackingTemplateUuid') {
            data.value = templateKey
          }
        }
      }
      this.configContent = JSON.stringify(this.searchForm)
    },
    initDate(removeDate, templateKey) {
      if (this.searchForm && this.searchForm.length > 0) {
        for (const data of this.searchForm) {
          if (data.key === 'createTime') {
            if (removeDate) {
              data.value = ''
            } else {
              const nowDate = dateUtils.formatStandardDate(new Date())
              data.value = [nowDate, nowDate]
            }
          }
          if (data.key === 'trackingTemplateUuid') {
            data.value = templateKey
          }
        }
      }
      this.configContent = JSON.stringify(this.searchForm)
    },
    handleFilter() {
      this.configContent = JSON.stringify(this.searchForm)
      const search = this.searchForm.filter(item => item.value)
      const params = {}
      if (search && search.length > 0) {
        for (const data of search) {
          if (data.key === 'createTime') {
            params['startTime'] = data.value[0]
            params['endTime'] = data.value[1]
            continue
          }
          params[data.key] = data.value
        }
      }
      const noSelectKeys = this.removeKeys()
      this.$emit('search', params, noSelectKeys)
    },
    restForm() {
      this.searchForm = JSON.parse(this.configContent)
      this.innerVisible = false
    },
    open() {
      this.getFilterConfig()
    },
    configChange(configContent) {
      this.configContent = configContent
    },
    clear() {
      if (this.searchForm && this.searchForm.length > 0) {
        for (const data of this.searchForm) {
          data.value = ''
        }
      }
      this.$emit('changeDate')
    },
    removeKeys() {
      const result = []
      const search = this.searchForm
      if (search && search.length > 0) {
        for (const data of search) {
          if (data.value === '' || data.value === null) {
            result.push(data.key)
          }
        }
      }
      return result
    },
    changeSelect(p, item) {
      item.value = p.value
      if (item.key === 'trackingTemplateUuid') {
        this.$emit('changeTrackingTemplateKey', p.value)
      }
    },
    changeDate(item) {
      console.info('changeDate', item)
      if (item.key === 'createTime') {
        this.$emit('changeDate')
      }
      if (!item.value) {
        this.clearDate(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.el-dropdown{
  width: 100%;
}
.el-dropdown-menu{
  width: 323.325px;
}
</style>
